<template>
  <div>
    <div class="module-title" v-if="!hideTitle">组织架构</div>
    <div class="module-title" v-if="hideTitle"></div>
    <div class="team-content">
      <div
        class="team-list"
        v-for="(item, index) in dataList"
        :key="index"
        @click="showImg(item)"
      >
        <img class="team-img" :src="application.imageHost + item.imagePath" />
        <!-- <div class="team-title">{{ item.name }}</div> -->
        <!-- <div class="team-text" v-html="item.content"></div> -->
      </div>
    </div>
    <preImg :imgSrc="imgSrc" v-if="isShow" @hideImg="hideImg"></preImg>
  </div>
</template>
<style src="./team.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import mixins from "../../common/mixin";
import preImg from "../preview/preview.vue";
import application from "../../common/application";
export default {
  name: "companyIntro",
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    swiper,
    swiperSlide,
    preImg,
  },
  data: () => ({
    dataList: [],
    imgSrc: "",
    isShow: false,
    application: application,
  }),
  mixins: [mixins],
  created() {
    this.getData();
  },
  methods: {
    hideImg() {
      this.isShow = false;
    },
    // 预览
    showImg(item) {
      this.isShow = true;
      this.imgSrc = this.application.imageHost + item.imagePath;
    },
    //获取数据
    getData() {
      let data = {
        pageIndex: 0,
        pageSize: 20,
      };
      this.request({
        url: "/web/introduce/team",
        data: data,
        success: (response) => {
          console.log(111);
          if (response.data.records.length) {
            this.dataList = [response.data.records[0]];
          }

          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/team/team.vue